<template>
  <div class="row transaction">
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>
    <div class="col-12" v-if="auth.merchant !== null">
      <p>Office Name: {{ auth.user.firstName }}</p>
    </div>

    <div class="col-md-4">
      <label for="inlineFormInput">Phone Number</label>
      <input type="text" class="form-control" v-model="phoneNumber" />
    </div>
    <div class="col-md-4">
      <label for="inlineFormInput">Email</label>
      <input type="text" class="form-control" v-model="email" />
    </div>
    <div class="col-md-4">
      <label for="inlineFormInput">Wallet Id</label>
      <input type="text" class="form-control" v-model="walletId" />
    </div>

    <div class="col-md-6 mt-4">
      <button class="btn btn-info" @click="refresh('refresh')">Refresh</button>
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">First Name</th>
                <th scope="col" class="text-center">Last Name</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Wallet Id</th>
                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(agent, index) in agents" :key="agent._id">
                <th class="text-center">{{ index + 1 }}</th>
                <td class="text-center">{{ agent.firstName }}</td>
                <td class="text-center">{{ agent.lastName }}</td>
                <td class="text-center">{{ agent.email }}</td>
                <td class="text-center">{{ agent.walletId }}</td>
                <td class="text-center">{{ agent.phoneNumber }}</td>
                <td class="text-center">
                  <router-link :to="`/dashboard/agent/${agent._id}`">
                    View Agent
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="mt-2 d-flex justify-content-end align-items-center">
      <div class="p-2" v-if="hasPrevPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('previous')"
        >
          Previous Page
        </button>
      </div>
      <div class="p-2" v-if="hasNextPage === true">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('next')"
        >
          Next Page
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      loading: false,
      error: false,
      agents: [],
      errorMsg: "",
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      //   totalDocs: 37,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      phoneNumber: "",
      email: "",
      walletId: "",
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    ...mapActions(["getMerchant"]),
    async refresh(mode) {
      try {
        this.loading = true;
        let payload = {
          page: this.page,
          phoneNumber: this.phoneNumber,
          email: this.email,
          walletId: this.walletId,
        };
        switch (mode) {
          case "next":
            payload = { page: this.nextPage };
            break;
          case "previous":
            payload = { page: this.prevPage };
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/merchant/get-agents`,
          payload,
        );
        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
        } = res.data.agents;
        this.agents = docs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Agent";
      }
      this.loading = false;
    },
  },
  async mounted() {
    // console.log(this.auth)
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/merchant/get-agents`,
        {
          page: this.page,
        },
      );
      const { docs, hasNextPage, hasPrevPage, totalPages, prevPage, nextPage } =
        res.data.agents;
      this.agents = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Agents";
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
</style>
